import type { Profile, ProfileWithBranches, Branch } from '../types/database';

export function isProfileWithBranches(profile: Profile | null): profile is ProfileWithBranches {
  return profile !== null && 
    'profile_branches' in profile && 
    Array.isArray(profile.profile_branches) &&
    'last_used_branch' in profile;
}

export function isBranch(value: any): value is Branch {
  return (
    value !== null &&
    typeof value === 'object' &&
    typeof value.id === 'string' &&
    typeof value.name === 'string' &&
    typeof value.invoice_prefix === 'string' &&
    typeof value.is_active === 'boolean'
  );
}

export function isBranchArray(value: any): value is Branch[] {
  return Array.isArray(value) && value.every(isBranch);
}

// New type guard to check if a profile has a role
export function hasRole(profile: Profile | null): profile is Profile & { role: string } {
  return profile !== null && typeof profile.role === 'string';
} 